import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getTableSearchBarStyles } from './SearchBarStyles';
function SearchBar(inputBarProps) {
  var onTextChangeHandler = inputBarProps.onTextChangeHandler;
  var tableSearchStyles = getTableSearchBarStyles();
  return _jsx(View, Object.assign({
    style: tableSearchStyles.inputWrapper
  }, {
    children: _jsx(Input, Object.assign({
      placeholder: 'Search...',
      onChangeText: onTextChangeHandler
    }, inputBarProps))
  }));
}
export default SearchBar;